import graphql from './graphql';

const mutation = /* GraphQL */ `
  mutation Course_setDepartmentType($coursesData: [CourseData], $departmentId: String) {
    Course_setDepartmentType(coursesData: $coursesData, departmentId: $departmentId) {
      id
    }
  }
`;

const courseSetDepartmentType = async (coursesData, departmentId) => {
  graphql(mutation, { coursesData, departmentId })
    .then(data => data.Course_setDepartmentType)
    .catch(e => e);
};

export default courseSetDepartmentType;
